"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var baseCns = ['br-p-4', 'br-shadow-card', 'br-mb-4', 'br-rounded-default', 'br-w-full'];
var selectedCns = ['br-bg-white', 'br-border', 'br-border-blue-brenger'];
var defaultCns = ['br-bg-white', 'br-border', 'br-border-gray-300'];
var typeCns = {
    primary: ['br-bg-blue-200', 'br-text-blue-600'],
    gray: ['br-bg-gray-100', 'br-border-l-4', 'br-border-gray-300'],
    stale: ['br-bg-stale-50', 'br-border-l-4', 'br-border-gray-300'],
    orange: ['br-bg-orange-100', 'br-border-l-4', 'br-border-orange-300'],
    red: ['br-bg-red-100', 'br-border-l-4', 'br-border-red-300'],
    'orange-outline': ['br-border', 'br-border-orange-400'],
    'red-outline': ['br-border', 'br-border-red-400'],
    'green-left-outline': ['br-border-l-4', 'br-border-green-300'],
    'red-bg-gray': ['br-bg-gray-100', 'br-border-l-4', 'br-border-red-300'],
    'orange-bg-gray': ['br-bg-gray-100', 'br-border-l-4', 'br-border-orange-300'],
    'light-blue': ['br-bg-blue-50', 'br-text-blue-600']
};
var Card = function (_a) {
    var className = _a.className, type = _a.type, isSelected = _a.isSelected, unused = __rest(_a, ["className", "type", "isSelected"]);
    var colorClasses = (isSelected ? selectedCns : typeCns[type]) || defaultCns;
    return react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)(baseCns, className, colorClasses) }, unused));
};
exports.Card = Card;
